import {useCallback, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Form} from "antd";
import {onSelectTemplate} from "./CustomFields";
import {saveEmail} from "../../store/actions/emailAction";
import Constants from "../../utils/constants";

const initialValues = {mail: [], cc: [], object: '', email_message: '', pieces_jointes: []};

export const useMaillerForm = ({action, mails, document, bdd, langue}) => {
	const {templates, templatesLangues, parametre, utilisateur} = useSelector((state) => ({
		templates: state.templates.data,
		templatesLangues: state.templatesLangues.data,
		parametre: state.parametre?.data,
		utilisateur: state.utilisateur.data,
		})
	)
	const { requete } = bdd;
	const dispatch = useDispatch();

	const [innerForm] = Form.useForm();
	const [open, setOpen] = useState(false); // Select Mail
	const [isSending, setIsSending] = useState(false);
	const [checked, setChecked] = useState(parametre?.parametre_signature); // Checkbox signature

	const [signatureHtml, setSignatureHtml] = useState(parametre?.parametre_signature || "");

	// state du contenu des templates
	const [templateHtml, setTemplateHtml] = useState("");
	const [faqSelection, setFaqSelection] = useState(null); // { html, id, ts }

	//state de la selection de faq et template
	const [selectedFaqId, setSelectedFaqId] = useState(null);
	const [selectedTemplateId, setSelectedTemplateId] = useState(null);

	const [isUploading, setIsUploading] = useState(false);

	// 1. Gérer la réinitialisation lors du changement de 'mails' (changement de destinataire/contexte)
	useEffect(() => {
		const currentValues = innerForm.getFieldsValue();
		innerForm.setFieldsValue({
			...initialValues,
			// On garde les pièces jointes actuelles si on veut,
			// ou on les vide si c'est vraiment un changement de contexte total
			pieces_jointes: currentValues.pieces_jointes || [],
			mail: mails.length > 0 ? [mails[0].value] : []
		});
		setTemplateHtml("");
		setSelectedFaqId(null);
		setSelectedTemplateId(null);
		setFaqSelection(null);
	}, [mails, innerForm]);

	// 2. Gérer l'ajout spécifique d'un document sans écraser le reste
	useEffect(() => {
		if (document) {
			const currentPieces = innerForm.getFieldValue('pieces_jointes') || [];
			const exists = currentPieces.find(f => f.uid === document.uid);

			if (!exists) {
				innerForm.setFieldsValue({
					pieces_jointes: [...currentPieces, document]
				});
			}
		}
	}, [document, innerForm]);

	// Sélectionné le premier mail dans la liste des mails disponibles
	useEffect(() => {
		//console.log('passe useEffect useMaillerForm selectionne premier mail');
		let isMounted = true;
		if (isMounted && mails.length > 0 && innerForm) {
			innerForm.setFieldsValue({
				mail: [mails[0].value]
			});
		}
		return () => {
			isMounted = false; // Empêche les mises à jour après démontage
		};
	}, [innerForm, mails]);

	const handleSubmitClick = useCallback((e) => {
		e.preventDefault();
		e.stopPropagation();
		innerForm.submit();
	}, [innerForm]);

	const handleInnerSubmit = async (values) => {
		// Corps saisi dans l'éditeur (sans signature)
		const bodyHtml = values.email_message || "";
		// Signature externalisée => concaténation au submit
		const finalHtml = `${bodyHtml}${signatureHtml || ""}`;

		const uploaded = (values.pieces_jointes || [])
			.filter(f => f.status === "done")
			.map(f => ({
				nom: f.name,
				// url: `Requetes/${state.requete.requete_id}/`,
				// TODO : c'est de la merde (en attente de refonte)
				ref: f.ref ? f.ref : "Pieces_jointes/",
				url: f.url ? f.url : `${Constants.directory}documents/Pieces_jointes/${f.name}`,
				//size: f.size,
			}));

		// TODO : c'est de la merde (en attente de refonte)
		const payload = {
			//...values,
			email_objet: values.object,
			email_message: finalHtml,
			email_destinataire: values.mail[0],
			email_destinataire_array: values.mail.map(email => ({email:email, name:email})),
			email_copie: values?.cc.length > 0 ? values.cc[0] : "",
			email_copie_array: values.cc.length > 0 ? values.cc : [],
			email_pieces_jointes: uploaded,

			email_utilisateur_id: utilisateur.utilisateur_id,
			email_requete_id: bdd?.requete?.requete_id || null,
			email_template_id: bdd?.data?.email_template || null,

			parametre_smtp: parametre.parametre_smtp,
			parametre_port: parametre.parametre_port,
			parametre_email: parametre.parametre_email,
			parametre_mdp: parametre.parametre_mdp,
			parametre_copie_agence: parametre.parametre_copie_agence,
			parametre_email_copie: parametre.parametre_email_copie,
		};

		setIsSending(true); // Bloque le bouton
		try {
			await dispatch(saveEmail(payload));

			// Reset du formulaire après succès
			//innerForm.resetFields(['cc', 'object', 'email_message', 'pieces_jointes']);
			innerForm.setFieldsValue({...initialValues, mail: [mails[0].value]});
			setTemplateHtml("");
			setSelectedFaqId(null);
			setSelectedTemplateId(null);
			setFaqSelection(null);
		} catch (error) {
			console.error("Erreur lors de l'envoi", error);
		} finally {
			setIsSending(false); // Débloque le bouton
		}

	};

	/*
	Selection d'un template selon son ID et la langue
	*/
	const handleSelectTemplate = (templateId) => {

		setSelectedTemplateId(templateId ?? null);
		// Cas "clear" du Select (allowClear) => templateId = null/undefined
		if (!templateId) {
			setTemplateHtml("");
			return;
		}

		// Recherche du template dans les langues disponibles selon la langueCode et le templateId
		const result = templatesLangues.find(
			(item) =>
				item?.template_langue_template?.template_id === templateId &&
				item?.template_langue_langue?.langue_code === langue()
		);

		const text = onSelectTemplate(bdd, result?.template_langue_text, result?.template_langue_langue?.langue_id)

		innerForm.setFieldsValue({object: result?.template_langue_titre});
		setTemplateHtml(text || "");
		//setTemplateHtml(result?.template_langue_text || "");
	};

	/*
	Selection d'un template FAQ selon son ID et la langue
	*/
	const handleSelectFAQ = (faqId) => {
		setSelectedFaqId(faqId ?? null);
		if (!faqId) {
			// Pas d'effacement de l'éditeur ici, on ne fait rien
			return;
		}

		const result = templatesLangues.find(
			(item) =>
				item.template_langue_template.template_id === faqId &&
				item.template_langue_langue.langue_code === langue()
		);

		// Déclenche une insertion dans l'éditeur sans supprimer le contenu existant (template + saisie)
		setFaqSelection({html: result?.template_langue_text || "", id: faqId, ts: Date.now()});
	};

	const handleSelectSignature = e => {
		const signature = parametre?.parametre_signature || ""
		setSignatureHtml(e.target.checked ? signature : "")
		setChecked(e.target.checked)
	}

	return {
		templates,
		requete,
		innerForm,
		isSending,
		open,
		setOpen,
		checked,
		signatureHtml,
		templateHtml,
		faqSelection,
		selectedFaqId,
		selectedTemplateId,
		isUploading,
		setIsUploading,
		handleSubmitClick,
		handleInnerSubmit,
		handleSelectTemplate,
		handleSelectFAQ,
		handleSelectSignature
	};
};
